import React, { useState,useEffect } from "react";
import { toast } from 'react-toastify';
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";

const SettingsTab = ({ updateSpinningWheelTabData,spinningWheelTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [selectedShowPopup, setSelectedShowPopup] = useState(spinningWheelTabData.show_popup_type);
    const [showPopupDropdown, setShowPopupDropdown] = useState(false);
    const [isShowReopenButton, setIsShowReopenButton] = useState(Number(spinningWheelTabData.is_show_reopen_button));
    const [buttonText, setButtonText] = useState(spinningWheelTabData.button_text);
    const [activeButtonPosition, setActiveButtonPosition] = useState(spinningWheelTabData.button_position);
    const [displayPagesType, setDisplayPagesType] = useState(spinningWheelTabData.pages_types);
    const [selectedDevices, setDisplayDevicesType] = useState(spinningWheelTabData.devices_types);
    const [selectedShowLanguage, setSelectedLanguage] = useState(spinningWheelTabData.language_types);
    const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(spinningWheelTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(spinningWheelTabData.custom_js);

    //Handle Show Popup Dropdown Change
    const toggleShowPopupDropdown = () => {
        setShowPopupDropdown(!showPopupDropdown);
    };
    //Handle Show Popup Change
    const handleShowPopupSelect = (type) => {
        setSelectedShowPopup(type);
        updateSpinningWheelTabData("show_popup_type", type); 
        setShowPopupDropdown(false); 
    };

    //Handle Show Reopen Button toggle
    const handleIsShowReopenButtonToggle = (e) => {
        const checked = e.target.checked;
        setIsShowReopenButton(checked);
        updateSpinningWheelTabData('is_show_reopen_button', checked);
    };

    //Handlers Button Text Change
    const handleButtonTextChange = (e) => {
        const value = e.target.value;
        setButtonText(value);
        updateSpinningWheelTabData("button_text", value); 
    };

    // Handle Button Position change
    const handleActiveButtonPositionChange = (event) => {
        setActiveButtonPosition(event.target.value);
        updateSpinningWheelTabData("button_position", event.target.value);
    };

    // Handlers Where to Display Pages Change
    const handleDisplayPagesTypeChange = (event) => {
        const value = event.target.value;
        setDisplayPagesType(value);
        updateSpinningWheelTabData("pages_types", value);
    };

    // Handlers Where to Display Devices Change
    const handleDisplayDevicesTypeChange = (event) => {
        const value = event.target.value;
        setDisplayDevicesType(value);
        updateSpinningWheelTabData("pages_types", value);
    };

    //Handle Show Language Dropdown Change
    const toggleShowLanguageDropdown = () => {
        setShowLanguageDropdown(!showLanguageDropdown);
    };
    //Handle Show Language Change
    const handleShowLanguageSelect = (type) => {
        setSelectedLanguage(type);
        updateSpinningWheelTabData("language_types", type); 
        setShowLanguageDropdown(false); 
    };
    
    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateSpinningWheelTabData("custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);
    
    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateSpinningWheelTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
         <div className="side-baar-inner-setting">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Settings</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Show Popup</span>
                            <div className="form-group mt-0">
                                <em className="mt-0" onClick={toggleShowPopupDropdown}>{selectedShowPopup}</em>
                            </div>
                            {showPopupDropdown && (
                                <ul className="dropdown-list h-auto">
                                    {['Instantly'].map((type) => (
                                        <li key={type} onClick={() => handleShowPopupSelect(type)}>
                                            {type}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Reopen Button</span>
                            <div className="form-group">
                                <input
                                    type="checkbox"
                                    id="reopen_button_toggle"
                                    className="chkbx-toggle"
                                    checked={isShowReopenButton}
                                    onChange={handleIsShowReopenButtonToggle}
                                />
                                <label htmlFor="reopen_button_toggle"></label>
                            </div>
                        </div>
                        <div className="box-header-row bubble-text">
                            <label>Button Text</label>
                            <input name="button_text" value={buttonText} onChange={handleButtonTextChange}
                            placeholder="Button Text..." type="text" />
                        </div>
                        <div className="box-header-row">
                            <p>Button Position</p>
                            <div className="left-cnater-right-button mb-0">
                                <label className="card-radio-btn">
                                    <input type="radio" name="button_position_type" className="card-input-element d-none" value="left-side" onChange={handleActiveButtonPositionChange} checked={activeButtonPosition === "left-side"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Left</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="button_position_type" className="card-input-element d-none" value="top-left-side" onChange={handleActiveButtonPositionChange} checked={activeButtonPosition === "top-left-side"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Top Left</div>
                                    </div>
                                </label>
                                 </div>
                                <div className="left-cnater-right-button mb-0 mt-0">
                                <label className="card-radio-btn">
                                    <input type="radio" name="button_position_type" className="card-input-element d-none" value="top-side" onChange={handleActiveButtonPositionChange} checked={activeButtonPosition === "top-side"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Top</div>
                                    </div>
                                </label>
                               
                                <label className="card-radio-btn">
                                    <input type="radio" name="button_position_type" className="card-input-element d-none" value="top-right-side" onChange={handleActiveButtonPositionChange} checked={activeButtonPosition === "top-right-side"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Top Right</div>
                                    </div>
                                </label>
                                 </div>
                                <div className="left-cnater-right-button mb-0 mt-0">
                                <label className="card-radio-btn">
                                    <input type="radio" name="button_position_type" className="card-input-element d-none" value="right-side" onChange={handleActiveButtonPositionChange} checked={activeButtonPosition === "right-side"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Right</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="button_position_type" className="card-input-element d-none" value="bottom-left-side" onChange={handleActiveButtonPositionChange} checked={activeButtonPosition === "bottom-left-side"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Bottom Left</div>
                                    </div>
                                </label>
                                </div>
                                <div className="left-cnater-right-button mb-0 mt-0">
                                <label className="card-radio-btn">
                                    <input type="radio" name="button_position_type" className="card-input-element d-none" value="bottom-side" onChange={handleActiveButtonPositionChange} checked={activeButtonPosition === "bottom-side"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Bottom</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="button_position_type" className="card-input-element d-none" value="bottom-right-side" onChange={handleActiveButtonPositionChange} checked={activeButtonPosition === "bottom-right-side"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Bottom Right</div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("pages")}>Pages <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("devices")}>Devices <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                    <p>Adjust popups’s visibility for your website's pages and user devices. You can also set up a display schedule.</p> 

                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Language</span>
                            <div className="form-group mt-0">
                                <em className="mt-0" onClick={toggleShowLanguageDropdown}>{selectedShowLanguage}</em>
                            </div>
                            {showLanguageDropdown && (
                                <ul className="dropdown-list">
                                    {['English'].map((type) => (
                                        <li key={type} onClick={() => handleShowLanguageSelect(type)}>
                                            {type}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>   
                    </div>  

                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div> 
                </>
            )}

            {activeSettingElementsTab === "pages" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Pages</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul className="pages-list">
                                    <li>
                                        <div className="form-group">
                                            <input id="pages_types" type="radio" value="All_Pages" onChange={handleDisplayPagesTypeChange} checked={displayPagesType === 'All_Pages'}/>
                                            <label for="pages_types">All Pages</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="pages_types2" type="radio" value="Homepage" onChange={handleDisplayPagesTypeChange} checked={displayPagesType === 'Homepage'}/>
                                            <label for="pages_types2">Homepage</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "devices" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Devices</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul className="pages-list">
                                    <li>
                                        <div className="form-group">
                                            <input id="device_types" type="radio" value="All_Pages" onChange={handleDisplayDevicesTypeChange} checked={selectedDevices === 'All_Pages'}/>
                                            <label for="device_types">All Pages</label>All Devices
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="device_types2" type="radio" value="All_Devices" onChange={handleDisplayDevicesTypeChange} checked={selectedDevices === 'All_Devices'}/>
                                            <label for="device_types2">All Devices</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}

        </div>
    );
};

export default SettingsTab;